// extraScoreStarAnimation.js
var ExtraScoreStarAnimation = pc.createScript('extraScoreStarAnimation');

ExtraScoreStarAnimation.attributes.add("pointA", {type: "entity", title: "Point A"});
ExtraScoreStarAnimation.attributes.add("pointB", {type: "entity", title: "Point B"});
ExtraScoreStarAnimation.attributes.add("pointC", {type: "entity", title: "Point C"});
ExtraScoreStarAnimation.attributes.add("type", {type: "string"});

// initialize code called once per entity
ExtraScoreStarAnimation.prototype.initialize = function() {
    this.speed = 5;
    this.time = 0;
};

// update code called every frame
ExtraScoreStarAnimation.prototype.update = function (dt) {
    this.time += dt; 
    if (this.time > this.speed) {
        this.time -= this.speed;
    }    
    var percent = this.time / this.speed;
    var position = this.entity.getPosition();

    if (this.type == "single") {
        position.lerp(this.pointA.getPosition(), this.pointB.getPosition(), percent);
        
        if (position.x >= 0.2580) {
            this.entity.destroy();
        }
    }
    else {
        position.lerp(this.pointA.getPosition(), this.pointC.getPosition(), percent);

        if (position.x >= 0.50) {
            this.entity.destroy();
        }
    }
    this.entity.setPosition(position);
};

ExtraScoreStarAnimation.prototype.changeType = function(inputType) {
    this.type = inputType;
};


